import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import queryString from 'query-string'
import { API_BASE_URL } from 'common/utils/apiConstants'
import { auth0Token } from 'common/utils/authUtils'

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: async (headers) => {
    // ? why isn't this handled by middleware
    const token = await auth0Token.getAccessTokenSilently()

    if (token != null) {
      headers.set('Authorization', `Bearer ${token}`)
    }

    return headers
  },
  /**
   * It was decided with backend that given a parameter with multiple values,
   * we should specify the parameter multiple times within the query string.
   * Example: ([API_URL]?names=Brian&names=Jackie&names=Sunny&name=Deep)
   */
  paramsSerializer: (params: Record<string, unknown>) => {
    // Returns query string specified in the format above (See above comment)
    // For details about customization, see query-string library:
    // https://github.com/sindresorhus/query-string
    return queryString.stringify(params)
  }
})
